module.exports = "<div class=\"form-group\">\n  <label class=\"col-sm-2 control-label\">{{displayName}}</label>\n  <div class=\"col-sm-10\">\n    {{value}}\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin/shared/formcontrol-subdocument/formcontrol-subdocument.component.html
// module id = 304
// module chunks = 0 1